<div class="content-container">
  <div class="center">
    <h1 class="face"><i class="far fa-frown"></i></h1>
    <p class="error">{{ errorMessage }}</p>
    <div class="input-button">
      <button (click)="onButtonClicked()">{{ locale.tryAgain }}</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/connection-error/connection-error.component.html